// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper-form[data-v-81494bce] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem /* 16px */;\n}\n.col-span-2[data-v-81494bce] {\n  grid-column: span 2 / span 2;\n}\n.wapper-buttons[data-v-81494bce] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-top: 0.5rem /* 8px */;\n}\n", ""]);
// Exports
module.exports = exports;
